/**
 * 📊 BAR CHART WIDGET
 * ════════════════════════════════════════════════════════════════════════
 * 
 * Widget para gráficos de barras (DRIVERS, comparaciones).
 * Props mínimas, sin lógica de layout.
 */

import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from 'recharts';
import type { ExecutiveWidget } from '../types';
import { getWidgetSeriesCache } from '../../../shared/utils/seriesCache';

interface BarChartWidgetProps {
  widget: ExecutiveWidget;
}

const BarChartWidget: React.FC<BarChartWidgetProps> = ({ widget }) => {
  
  const { detectedXField } = getWidgetSeriesCache({
    widgetId: widget.id,
    data: widget.data,
    defaultXField: 'category',
    defaultYField: 'valor',
  });
  const yField = 'valor';
  
  if (!detectedXField || !widget.data || widget.data.length === 0) {
    return <div className="widget-empty">Sin datos</div>;
  }
  
  return (
    <div className="bar-chart-widget">
      <h3 className="widget-title">{widget.title}</h3>
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={widget.data} margin={{ top: 10, right: 20, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" vertical={false} />
          <XAxis 
            dataKey={detectedXField} 
            stroke="rgba(255,255,255,0.15)"
            tick={{ fill: '#6b7280', fontSize: 12 }}
          />
          <YAxis 
            stroke="rgba(255,255,255,0.15)"
            tick={{ fill: '#6b7280', fontSize: 12 }}
          />
          <Tooltip
            contentStyle={{
              backgroundColor: '#1e2732',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: '8px',
              color: '#f0f4f8'
            }}
            labelStyle={{ color: '#f0f4f8', marginBottom: 4 }}
            itemStyle={{ color: '#3b82f6' }}
          />
          <Bar dataKey={yField} fill="#3b82f6" radius={[4, 4, 0, 0]} maxBarSize={64} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default BarChartWidget;
